import {
  ApiParams,
  BaseClient,
  IActionResponse,
  IActionResult,
  IPagedResult,
} from "../../../assets/utils/lib";
import { SearchOrganizationDto } from "../../../components/community/nonprofit/organization/organizationPage";
import { LookupDto } from "../../dto";
import { OrganizationDto } from "../../dto/nonprofit/organizationDto";
import { OrganizationGridDto } from "../../dto/nonprofit/organizationGridDto";

export class NonprofitOrganizationClient extends BaseClient {
  routes = ["nonprofit", "organization"];

  async getNonprofitOrganizationAsync(
    id: string | undefined
  ): Promise<OrganizationDto> {
    const actions: string[] = ["GetOrganization"];
    const params: ApiParams[] = [new ApiParams("organizationId", id, true)];

    const result: OrganizationDto = await this.getAsync<OrganizationDto>(
      actions,
      params
    );
    return result;
  }

  async searchNonprofitOrganizationsAsync(
    payload: SearchOrganizationDto | undefined
  ): Promise<IPagedResult<OrganizationGridDto>> {
    const actions: string[] = ["SearchNonprofitOrganizations"];
    const result: IPagedResult<OrganizationGridDto> = await this.postAsync<
      SearchOrganizationDto,
      OrganizationGridDto,
      IPagedResult<OrganizationGridDto>
    >(actions, payload);
    return result;
  }

  async saveNonprofitOrganizationAsync(
    payload: OrganizationDto | undefined
  ): Promise<IActionResult<OrganizationDto>> {
    const actions: string[] = ["SaveOrganization"];
    return await this.postAsync<OrganizationDto>(actions, payload);
  }

  async deActivateNonprofitOrganizationAsync(
    id: string | undefined
  ): Promise<IActionResponse> {
    const actions: string[] = ["DeActivateOrganization"];
    const params: ApiParams[] = [new ApiParams("id", id, true)];

    return await this.getAsync(actions, params);
  }

  async deleteOrganizationAsync(
    id?: string | undefined
  ): Promise<IActionResponse> {
    const actions: string[] = ["DeleteOrganization"];
    const params: ApiParams[] = [new ApiParams("organizationId", id, true)];
    return await this.deleteAsync(actions, params);
  }

  async getLookupsAsync(): Promise<{
    community: LookupDto[];
    state: LookupDto[];
    county: LookupDto[];
    category: LookupDto[];
  }> {
    const actions: string[] = ["GetLookups"];
    const result: {
      community: LookupDto[];
      state: LookupDto[];
      county: LookupDto[];
      category: LookupDto[];
    } = await this.getAsync<{
      community: LookupDto[];
      state: LookupDto[];
      county: LookupDto[];
      category: LookupDto[];
    }>(actions, []);
    return result;
  }

  async getCommunityOrganizationsAsync(
    communityId: string
  ): Promise<OrganizationDto[]> {
    const actions: string[] = ["GetAllOrganizations"];
    const params: ApiParams[] = [
      new ApiParams("communityId", communityId, true),
    ];

    const result: OrganizationDto[] = await this.getAsync<OrganizationDto[]>(
      actions,
      params
    );
    return result;
  }
}
